import {Deferred} from '../utils/deferred';
import {injectable} from 'inversify';

declare const FB_APP_ID: string;

const facebookConfig: facebook.InitParams = {
    appId            : FB_APP_ID,
    autoLogAppEvents : true,
    xfbml            : false,
    status           : true,
    version          : 'v13.0'
};

@injectable()
export class Facebook
{
    public promise: Promise<void>;
    public lastAuthResponse: facebook.AuthResponse|null = null;
    
    public constructor()
    {
        const scriptEl = document.createElement('script');
        scriptEl.src = `https://connect.facebook.net/${ -1 < window.location.pathname.indexOf("/eng") ? "en_US" : "hu_HU" }/sdk.js`;
        document.head.appendChild(scriptEl);

        const loadDeferred = new Deferred<void>();

        window.fbAsyncInit = async () => {
            try {
                console.debug('FB.init');
                FB.init(facebookConfig);

                await this.getLoginStatus(false);

                loadDeferred.resolve(undefined);
            }
            catch (error)
            {
                loadDeferred.reject(error);
            }
        };

        this.promise = loadDeferred.promise;
    }
    
    public async login(rerequest: boolean): Promise<facebook.AuthResponse>
    {
        await this.promise;
        
        const deferred = new Deferred<facebook.StatusResponse>();
        
        console.debug('facebook.login');
        FB.login(response => {
            deferred.resolve(response);
            this.lastAuthResponse = response ? response.authResponse : null;
        }, {
            scope: 'email',
            return_scopes: true,
            ...( rerequest ? {auth_type: 'rerequest'} : {} )
        });
        
        const response = await deferred.promise;

        return response.authResponse;
    }
    
    public async me(fields: string[]): Promise<any>
    {
        await this.promise;
        
        const deferred = new Deferred<any>();
        
        console.debug('facebook.me');
        FB.api(`/me?fields=${fields.join(',')}`, (response: any) => {
            if (!response || response.error)
                deferred.reject((response && response.error) || 'No error message');
            else
                deferred.resolve(response);
        });
        
        return await deferred.promise;
    }
    
    public async getLoginStatus(waitForInit: boolean = true): Promise<facebook.StatusResponse>
    {
        if (waitForInit)
            await this.promise;
        
        const deferred = new Deferred<facebook.StatusResponse>();
        
        FB.getLoginStatus(response => {
            if (!response)
                deferred.reject('No error message');

            deferred.resolve(response);
            this.lastAuthResponse = response ? response.authResponse : null;
        });
        
        return await deferred.promise;
    }

    public async parseXfbml(element: HTMLElement)
    {
        await this.promise;

        console.log(element);
        FB.XFBML.parse(element);
    }

    public async logout()
    {
        await this.promise;

        await new Promise(resolve => FB.logout(resolve));

        location.reload(false);
    }
}